import countries from '@/presentation/common/assets/countries.json'

export const countryCodeToLabel = (cca3: string, lang = 'spa'): string => {
  const country: Record<string, any> | undefined = countries.find((country) => country.cca3 === cca3)
  return country?.translations[lang].common || cca3
}
